import { DateTime } from '@ksyos/date-time';

export function formatDateIntoString<T extends Date | null | undefined>(date: T): T extends Date ? string : null {
    if (!date) {
        return null as T extends Date ? string : null;
    }

    return DateTime.from(date).format('YYYY-MM-DD') as T extends Date ? string : null;
}
